import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
export default function AlbumEdit() {
  const $ = _c(11);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h3 className="summary_title">집찍고 앱에서 사진 편집​</h3>;
    t1 = <p className="summary">AI로 물건 지우기, 밝기 조절, 모자이크</p>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="headline"><h4 className="order_title text_primary">1단계</h4><p className="order_desc">편집할 사진 선택하기</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li>{t2}<div className="headline"><h4 className="order_title text_primary">2단계</h4><p className="order_desc">편집으로 이동하기</p></div><Image className="img_guide" src="/image/desktop/popup/album02_01.png" alt={"1\uB2E8\uACC4 : \uD3B8\uC9D1\uD560 \uC0AC\uC9C4 \uC120\uD0DD\uD558\uAE30, 2\uB2E8\uACC4 : \uD3B8\uC9D1\uC73C\uB85C \uC774\uB3D9\uD558\uAE30"} width={100} height={100} /></li>;
    t4 = <h4 className="order_title text_primary">3단계</h4>;
    t5 = <p className="order_desc">원하는 편집 메뉴 사용하여 사진 편집하면 끝!</p>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Image className="img_guide" src="/image/desktop/popup/album02_02.png" alt={"\uAE30\uB2A5 1 : AI\uB85C \uBB3C\uAC74 \uC9C0\uC6B0\uAE30"} width={100} height={100} />;
    t7 = <Image className="remove1" src="/image/desktop/popup/album02_gif01.gif" alt={"\uC9C0\uC6B0\uB294 \uC7A5\uBA74"} width={100} height={100} />;
    t8 = <Image className="remove2" src="/image/desktop/popup/album02_gif02.gif" alt={"\uC9C0\uC6B0\uB294 \uC7A5\uBA74"} width={100} height={100} />;
    t9 = <Image className="img_guide" src="/image/desktop/popup/album02_03.png" alt={"\uAE30\uB2A5 2: \uBC1D\uAE30 \uC870\uC808, \uAE30\uB2A5 3 : \uBAA8\uC790\uC774\uD06C"} width={100} height={100} />;
    $[6] = t6;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t6 = $[6];
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <>{t0}{t1}<ol className="list_order">{t3}<li>{t4}{t5}<div className="group_view">{t6}{t7}{t8}{t9}<a className="banner" href="https://www.aipartner.com/help/faq?seq=294" target="_blank" rel="noopener"><Image src="/image/desktop/popup/album02_banner.png" alt={"\uBAA8\uC790\uC774\uD06C, \uBC1D\uAE30 \uC870\uC808, \uBB3C\uAC74 \uC9C0\uC6B0\uAE30, \uAC04\uD3B8 \uC0AC\uC9C4 \uD3B8\uC9D1\u200B\u200B\u200B. \uC790\uC138\uD788 \uBCF4\uAE30"} width={100} height={100} /></a></div></li></ol></>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  return t10;
}